export default __webpack_public_path__ + "static/media/UNDP_DRT.52c44e8f.png";